﻿//Convert any nb, en, sv, fi date to string date in selected locale 

import moment from 'moment';

export const parseDate = (date, locale, format) => {
  if (!date) return;
  if (date._isAMomentObject || date.includes('Date')) date = moment(date).format('L');
  let dateFormat;
  if (date.includes('/')) dateFormat = 'MM/DD/YYYY HH:mm:ss';
  if (date.includes('.')) dateFormat = 'DD.MM.YYYY HH:mm:ss';
  if (date.includes('-')) dateFormat = 'YYYY-MM-DD HH:mm:ss';
  return locale && format ? moment(date, dateFormat).locale(locale).format(format) : moment(date, dateFormat);
}